import React from 'react'
import { useFormikContext } from 'formik'
import { Typography } from '@mui/material'
import tw from 'twin.macro'
import { colors } from 'src/theme'
import { TeamPermissions } from 'src/interfaces/team'
import { PermissionsSelector } from './PermissionsSelector'

interface Props {
  teamPermissions: TeamPermissions
}

export const FormikPermissionsSelector = <T extends { permissions: string[] }>({
  teamPermissions,
}: Props) => {
  const { values, setFieldValue } = useFormikContext<T>()

  const togglePermission = (permissionsToToggle: string[]): void => {
    const current = values.permissions || []

    const areAllIncluded = permissionsToToggle.every((permission) => current.includes(permission))

    const nextPermissions = areAllIncluded
      ? current.filter((permission) => !permissionsToToggle.includes(permission))
      : [...current, ...permissionsToToggle.filter((permission) => !current.includes(permission))]

    setFieldValue('permissions', nextPermissions)
  }

  return (
    <div>
      <Typography variant="h6" color={colors.SHADES_GREY_400} css={tw`mb-2`}>
        Select permissions
      </Typography>
      {Object.entries(teamPermissions).map(([category, availablePermissions]) => (
        <PermissionsSelector
          key={category}
          category={category}
          availablePermissions={availablePermissions as string[]}
          selectedPermissions={values.permissions}
          togglePermission={togglePermission}
        />
      ))}
    </div>
  )
}
